
export default {
  name: 'VsMap',
  inheritAttrs: false,
  props: {
    ratio: {
      type: [String, Object],
      default: '16/9'
    },
    latitude: {
      type: [Number, String],
      default: null
    },
    longitude: {
      type: [Number, String],
      default: null
    },
    zoom: {
      type: [Number, String],
      default: 15
    },
    address: {
      type: String,
      default: null
    },
    name: {
      type: String,
      default: null
    }
  },
  computed: {
    src() {
      const parts = ['width=100%', 'height=100%', 'iwloc=B', 'output=embed']

      if (this.latitude && this.longitude) {
        parts.push(`q=loc:${this.latitude}+${this.longitude}`)
      } else if (this.address) {
        parts.push(`q=${this.address}+(${this.name})`)
      }

      if (this.zoom) {
        parts.push(`z=${this.zoom}`)
      }

      return encodeURI(`https://maps.google.com/maps?${parts.join('&')}`)
    },
    style() {
      return { backgroundColor: '#efeeec' }
    }
  }
}
